import { render, staticRenderFns } from "./templateContentHeaderText.vue?vue&type=template&id=55daf587&"
import script from "./templateContentHeaderText.vue?vue&type=script&lang=ts&"
export * from "./templateContentHeaderText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports